var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogotipo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 85,
    viewBox: "0 0 141 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logotipo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M69.9045 -0.000976562L40.5452 54.7974L69.9045 73.2258L98.8332 54.9365L69.9045 -0.000976562ZM69.8653 67.5235L46.2604 52.6764L69.8653 8.48304L93.1179 52.746L69.8653 67.4887V67.5235Z",
    fill: "#B5B4B4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M119.815 16.3062C108.58 16.3062 99.4592 24.8945 99.4592 35.4647C99.4592 46.035 108.58 54.6233 119.815 54.6233C131.05 54.6233 140.171 46.035 140.171 35.4647C140.171 24.8945 131.05 16.3062 119.815 16.3062ZM119.815 50.9029C111.242 50.9029 104.274 43.9835 104.274 35.4647C104.274 26.9459 111.242 20.0266 119.815 20.0266C128.388 20.0266 135.356 26.9459 135.356 35.4647C135.356 43.9835 128.388 50.9029 119.815 50.9029Z",
    fill: "#187A8B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M33.9688 21.1063L31.3069 24.2009C27.2358 20.8629 22.6557 19.1939 17.88 20.0979C15.1006 20.6195 12.7127 21.5931 10.8337 22.9143C5.90136 26.3566 4.17895 31.7808 4.49211 35.8142C5.11844 44.1939 11.6949 48.9923 18.3106 49.7572C18.3106 49.7572 28.8799 50.8003 33.1468 42.9074L20.1113 42.7336V38.6306L39.645 38.7002C39.5275 40.1258 37.4137 45.6891 33.1468 49.3747C27.3924 54.3469 19.1326 54.1383 19.1326 54.1383C14.0437 54.1383 5.66649 49.8963 2.96543 44.8198C1.98679 42.977 1.08644 41.3427 0.616687 39.2217C-0.909996 32.6501 0.77327 29.7989 1.63448 27.6084C3.08287 23.9227 6.95829 19.7502 11.186 17.8378C13.2608 16.899 16.6273 15.8559 19.9938 15.7168C22.0685 15.6125 25.5525 16.1341 27.3532 16.9686C30.798 18.568 34.008 21.141 34.008 21.141H33.9688V21.1063Z",
    fill: "#187A8B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M46.7695 77.4326H52.5631V78.4757H50.0969L50.0578 84.8387H49.0791L49.1183 78.4757H46.7695V77.4326Z",
    fill: "#187A8B"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M60.5869 77.5723H65.3627V78.6502H61.5656V80.7712H65.2061V81.8838H61.5656V84.0048H65.3627V84.9089H60.5869V77.5723Z",
    fill: "#187A8B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M79.0256 84.3863C78.6733 84.5254 78.0078 84.6645 77.1466 84.6645C74.9153 84.6645 73.4277 83.378 73.4277 81.1179C73.4277 78.7187 75.1501 77.3975 77.3815 77.3975C78.321 77.3975 78.869 77.5713 79.1039 77.6756L78.8298 78.5449C78.4775 78.4058 78.0078 78.3015 77.4206 78.3015C75.8548 78.3015 74.7195 79.2403 74.7195 81.0484C74.7195 82.8564 75.7373 83.7605 77.3815 83.7605C77.9295 83.7605 78.4775 83.6562 78.8298 83.5171L79.0256 84.3863Z",
    fill: "#187A8B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M93.2753 84.8406H91.9835V81.4331H88.4996V84.8406H87.2078V77.2954H88.4996V80.39H91.9835V77.2954H93.2753V84.8406Z",
    fill: "#187A8B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogotipo);
export default __webpack_public_path__ + "static/media/logotipo.3997519f8d67c0834d02b541f2b0c2f5.svg";
export { ForwardRef as ReactComponent };